module.exports = __webpack_public_path__ + "img/kyocera.83fbc761.png";